export default {
  name: "TableContainer",
  props: {
    title: String,
    searchText: String,
    hoverable: Boolean,
    withoutPadding: Boolean,
    showFooter: Boolean,
    showArchived: Boolean,
  },
  data() {
    return {};
  },
  methods: {},
  watch: {}
};



// WEBPACK FOOTER //
// ./src/components/_table-container/table-container.js